// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../settings.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./norgie.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.TwoLineCollapsibleContainerLabel--collapsibleLabel--_Oy6e {
}

.TwoLineCollapsibleContainerLabel--labelContainer--DTOsa {
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 66px;
  min-width: 240px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.TwoLineCollapsibleContainerLabel--labelContainer--DTOsa:hover {
  color: var(--text-hover);
}

.TwoLineCollapsibleContainerLabel--norgieLabelContainer--ufSOZ {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.TwoLineCollapsibleContainerLabel--mainText--uNLSt {
}

.TwoLineCollapsibleContainerLabel--secondaryText--sLi0k {
}

.TwoLineCollapsibleContainerLabel--secondaryLabel--IdtCy {
}

@media print {

  .TwoLineCollapsibleContainerLabel--labelContainer--DTOsa {
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    text-overflow: ellipsis;
    max-width: 280px;
    min-width: 200px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: auto;
  }

  .TwoLineCollapsibleContainerLabel--mainText--uNLSt{
  }

  .TwoLineCollapsibleContainerLabel--secondaryText--sLi0k,
  .TwoLineCollapsibleContainerLabel--secondaryLabel--IdtCy {
  }

}`, "",{"version":3,"sources":["webpack://./src/components/settings/common/TwoLineCollapsibleContainerLabel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;AAEA;;AAEA;EAEE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAEE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;;EAEE;IAEE,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;EACd;;EAEA;EAEA;;EAEA;;EAGA;;AAEF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.collapsibleLabel {\n  composes: settingsHeaderDecoration settingsHeaderLayout settingsHeaderText from '../settings.css';\n}\n\n.labelContainer {\n  composes: defaultSize mediumContrastText from '../../../styles/typography.css';\n  cursor: pointer;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 66px;\n  min-width: 240px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.labelContainer:hover {\n  color: var(--text-hover);\n}\n\n.norgieLabelContainer {\n  composes: norgie from './norgie.css';\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.mainText {\n  composes: boldText from '../../../styles/typography.css';\n}\n\n.secondaryText {\n  composes: secondaryText from '../settings.css';\n}\n\n.secondaryLabel {\n  composes: lightText from '../../../styles/typography.css';\n}\n\n@media print {\n\n  .labelContainer {\n    composes: defaultSize mediumContrastText from '../../../styles/typography.css';\n    cursor: pointer;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row-reverse;\n    text-overflow: ellipsis;\n    max-width: 280px;\n    min-width: 200px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    height: auto;\n  }\n\n  .mainText{\n    composes: mainHeaderText from '../settings.css';\n  }\n\n  .secondaryText,\n  .secondaryLabel {\n    composes: secondaryText from '../settings.css';\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsibleLabel": `TwoLineCollapsibleContainerLabel--collapsibleLabel--_Oy6e ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeaderDecoration"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeaderLayout"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeaderText"]}`,
	"labelContainer": `TwoLineCollapsibleContainerLabel--labelContainer--DTOsa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["mediumContrastText"]}`,
	"norgieLabelContainer": `TwoLineCollapsibleContainerLabel--norgieLabelContainer--ufSOZ ${___CSS_LOADER_ICSS_IMPORT_2___.locals["norgie"]}`,
	"mainText": `TwoLineCollapsibleContainerLabel--mainText--uNLSt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boldText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mainHeaderText"]}`,
	"secondaryText": `TwoLineCollapsibleContainerLabel--secondaryText--sLi0k ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondaryText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondaryText"]}`,
	"secondaryLabel": `TwoLineCollapsibleContainerLabel--secondaryLabel--IdtCy ${___CSS_LOADER_ICSS_IMPORT_1___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondaryText"]}`
};
export default ___CSS_LOADER_EXPORT___;
